import {BaseClass} from '../../classes/baseClass';
import {formatUrl} from '../../helpers';
import {http} from '@teemill/common/services';

/**
 * address.js
 *
 * Defines the standard structure for an address object.
 */
export default class Address extends BaseClass {
  static modelName = 'address';

  constructor({
    id,
    firstName,
    lastName,
    company,
    streetAddress,
    city,
    zip,
    state,
    country,
  } = {}) {
    super();

    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.company = company;
    this.streetAddress = streetAddress;
    this.city = city;
    this.zip = zip;
    this.state = state;
    this.country = country;
  }

  update(properties) {
    return http
      .put(
        formatUrl(`/omnis/v3/shop/manufacturer/address/${this.id}/`),
        properties
      )
      .success(group => Address.map(group));
  }

  static create(properties) {
    return http
      .post(formatUrl('/omnis/v3/shop/manufacturer/address/'), properties)
      .success(address => Address.map(address));
  }

  static get() {
    return http
      .get(formatUrl('/omnis/v3/shop/manufacturer/address/'))
      .success(address => Address.map(address));
  }
}
